import { CHANGE_PAGE_TEMPLATE, CHANGE_PAGE_ORIENTATION, CHANGE_PAGE_SIZE, CHANGE_PAGE_MARGINS, CHANGE_PREVIEW_HIDDEN_COMPONENTS, } from '../constants';
export const page = (state = {
    templateIdent: '',
    template: {},
    pageTemplates: [],
    size: '', // A4 | A3
    orientation: '', // portrait | landscape
    margins: true,
    hiddenPreviewComponents: [],
}, action) => {
    let newState;
    switch (action.type) {
        case CHANGE_PREVIEW_HIDDEN_COMPONENTS:
            return {
                ...state,
                hiddenPreviewComponents: [...action.hiddenComponents],
            };
        case CHANGE_PAGE_TEMPLATE:
        case CHANGE_PAGE_SIZE:
        case CHANGE_PAGE_ORIENTATION:
        case CHANGE_PAGE_MARGINS:
            newState = {
                ...state,
                ...action,
            };
            newState = {
                ...newState,
                ...getRightSizeOrientation(newState),
            };
            return {
                ...newState,
                ...{
                    pageTemplates: newState.template.pageSize[newState.size][newState.orientation].pageTemplates,
                },
            };
        default:
            return state;
    }
};
/**
 * Vrati objekt se spravnou velikosti a orientaci stranky
 * Pokud by doslo ke zmene sablony, nebo velikosti stranky, kde treba uz neni A3, tak se nastavi prvni moznost
 * @param state {}
 */
export const getRightSizeOrientation = (state) => {
    const pageSize = state.template.pageSize;
    if (!pageSize)
        return {};
    const size = pageSize[state.size] ? state.size : Object.keys(pageSize)[0] || state.size;
    const orientation = !pageSize[size] || pageSize[size][state.orientation]
        ? state.orientation
        : Object.keys(pageSize[size])[0] || state.orientation;
    return { size, orientation };
};
//# sourceMappingURL=page.js.map